import { Component, OnInit } from '@angular/core';
import { AlertService } from '../alert/alert.service';
import { User } from '../user';
import { ForgotPassword } from '../services/forgotpassword.service';
import { UserService } from '../services/userservice.service';
import { Validators } from '@angular/forms';
import { Router } from '@angular/router';

interface forgotpassword {
  flaglogin: any;
  
}
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})

    // success(message: string, alertId: string) {
    // this.alertService.success(message, alertId);

    
    export class ForgotPasswordComponent implements OnInit {
      
      user: User = new User();
      submitted = false;
      tokens : any;
  isNew = true;
  message: string;
    
   
      constructor(
        private alertService: AlertService,

        private UserService: UserService,
     
private ForgotPassword:ForgotPassword,
       
        private router: Router
      ) {}
    
     
      
     success(message: string, alertId: string) {
     this.alertService.success(message, alertId);
     }

 
     ngOnInit() 
     {
   
       
     } 
     onSubmit() 
     {

      
     }

  forgotpassword() {
    this.ForgotPassword.ForgotPasswordCustomer(this.user.email)
      .subscribe(
        data => {
          console.log(data);
          if (data && data.status === 'Success') {
            (<any> $('#session-time-out')).modal('show');
            this.isNew = false;
            
            // alert('An Email with reset password is sent to your registered email');
            // this.router.navigate(['/register'])
          } else {
            this.isNew = false;
            this.message = 'Invalid email id';
          }
          console.log(this.tokens);
        },
        error => {
          console.log('Email Not Found');
        }
      );

  }
  }